module.exports = __webpack_public_path__ + "static/img/5_1_1.785bdb7e.jpg";